export default class KinoPermissions{

    constructor(){
        this.features={};
        this.rules={};
        this.role={};
        this.user=USER_ID;
        this.allow_join=ALLOW_JOIN;
        this.isHost=HOST == 1;
        this.restricted=RESTRICTED == 1;
        this.verified_member=(IS_VERIFIED_MEMBER == 1);
        this.kinoRole=ROLE;

    }

    setPermissions({features,rules,role,user}){
        this.features=features;
        this.rules=rules;
        this.role=role;
        this.user=user;
    }

    setRole(role){
        this.kinoRole=role;
    }
    getRole(){
        return this.kinoRole
    }

    isVerifiedMember(){
        return this.verified_member;
    }
    isMod(){
        return this.isHost || this.kinoRole == "moderator";
    }
    canJoinKino(){
        return this.allow_join;
    }

    initialSpace(){
        return false
    }
    leaveFallbackAssigned(){
        return false
    }
    shouldRequestToJoin(){
        if(this.isHost){
            return false
        }
        return this.restricted;
    }
    shouldMuteChatter(){
        return true;
    }
    shouldLockChatter(){
        return true;
    }
    shouldLockSpaces(){
        return false
    }

    shouldMuteMicrophone(){
        return false;
    }

    shouldRequestToJoinPrivateSpace(){
        return !this.isMod()
    }
    //workspace check features
    hasChat(){
        return true;
    }
    hasWave(){
        return true
    }
    hasSpacesManager(){
         return this.isMod()
    }
    hasStageView(){
        return this.isMod()
    }
    hasAnnouncer(){
        return this.isMod()
    }
    hasKinoTimer(){
        return this.isMod()
    }
    hasSpacesLock(){
        return this.isMod()
    }
    hasPrivateSpaces(){
        return true
    }
    hasMuteAll(){
        return this.isMod()
    }
    hasMuteLock(){
        return this.isMod()
    }
    hasAddSpaces(){
        return this.isMod()
    }
    hasChatterLock(){
        return this.isMod()
    }
    hasMuteChatter(){
        return this.isMod()
    }
    hasShareScreen(){
        return true
    }
    hasInvite(){
        return true
    }
    hasShowTheDoor(){
        return this.isMod()
    }
    hasChangeVolume(){
       return true
    }
    hasKinoRecorder(){
        return this.isMod()
    }
    hasLiveStreaming(){
        return this.isMod()
    }
    canAcceptUsers(){
        return this.isMod()
    }

};
